!function () {
  "use strict";
  const e = "[data-shopify-xr]", t = "[data-product-single-media-group]", s = "data-shopify-model3d-id";

  class i extends window.theme.DeferredMedia {
    constructor() {
      super()
    }

    loadContent() {
      super.loadContent(), this.modelId = this.element.dataset.modelId, this.xrButton = this.mediaContainer.closest(t)?.parentElement.querySelector(e), Shopify.loadFeatures([{
        name: "model-viewer-ui",
        version: "1.0",
        onLoad: this.setupModelViewerUI.bind(this)
      }])
    }

    setupModelViewerUI(e) {
      e ? console.warn(e) : (this.modelViewerUI = new Shopify.ModelViewerUI(this.element), this.setupModelViewerListeners())
    }

    setupModelViewerListeners() {
      this.mediaContainer.addEventListener("theme:media:visible", (() => {
        this.xrButton.setAttribute(s, this.modelId), window.theme.touch || (this.modelViewerUI.play(), this.mediaContainer.dispatchEvent(new CustomEvent("theme:media:play"), {bubbles: !0}))
      })), this.mediaContainer.addEventListener("theme:media:hidden", (() => {
        this.modelViewerUI.pause()
      })), this.mediaContainer.addEventListener("xrLaunch", (() => {
        this.modelViewerUI.pause()
      })), this.element.addEventListener("load", (() => {
        this.xrButton.setAttribute(s, this.modelId), this.mediaContainer.dispatchEvent(new CustomEvent("theme:media:play"), {bubbles: !0})
      })), this.element.addEventListener("shopify_model_viewer_ui_toggle_play", (() => {
        this.pauseOtherMedia(), setTimeout((() => {
          this.mediaContainer.dispatchEvent(new CustomEvent("theme:media:play"), {bubbles: !0})
        }), 50)
      })), this.element.addEventListener("shopify_model_viewer_ui_toggle_pause", (() => {
        this.mediaContainer.dispatchEvent(new CustomEvent("theme:media:pause"), {bubbles: !0})
      })), this.pauseOtherMedia()
    }
  }

  window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([{name: "shopify-xr", version: "1.0", onLoad: this.setupShopifyXR.bind(this)}])
    }, setupShopifyXR(e) {
      e ? console.warn(e) : window.ShopifyXR ? (document.querySelectorAll('[id^="ModelJson-"]').forEach((e => {
        window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove()
      })), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", (() => this.setupShopifyXR()))
    }
  }, window.addEventListener("DOMContentLoaded", (() => {
    window.ProductModel && window.ProductModel.loadShopifyXR()
  })), customElements.get("products-list-component") || customElements.define("products-list-component", class extends HTMLElement {
    constructor() {
      super(), this.flktyImages = [], this.flktyContent = [], this.sliderResizeEvent = () => this.resizeSlider()
    }

    connectedCallback() {
      this.tabButtons = this.querySelectorAll("[data-tab-button]"), this.tabItems = this.querySelectorAll("[data-tab-item]"), this.slidersImages = this.querySelectorAll("[data-slider-images]"), this.slidersContents = this.querySelectorAll("[data-slider-contents]"), this.initButtons(), this.initSliders(), this.initShopifyXrLaunch(), this.listen()
    }

    listen() {
      (this.slidersImages.length > 0 || this.slidersContents.length > 0) && document.addEventListener("theme:resize", this.sliderResizeEvent)
    }

    resizeSlider() {
      this.flktyImages.length > 0 && requestAnimationFrame((() => {
        this.flktyImages.forEach((e => e.resize()))
      })), this.flktyContent.length > 0 && requestAnimationFrame((() => {
        this.flktyContent.forEach((e => e.resize()))
      }))
    }

    initButtons() {
      this.tabButtons.forEach((e => {
        e.addEventListener("click", (t => {
          if (e.classList.contains("products-list__nav__button--active")) return;
          const s = e.getAttribute("href"), i = this.querySelector(s), n = i.querySelector("[data-circle-text]");
          this.tabButtons.forEach((e => {
            e.classList.remove("products-list__nav__button--active")
          })), this.tabItems.forEach((e => {
            const t = e.querySelector("[data-circle-text]");
            e.classList.remove("products-list__item--active"), t?.classList.add("is-disabled"), theme.settings.animationsEnabled && e.querySelectorAll(".aos-animate").forEach((e => {
              e.classList.remove("aos-animate"), setTimeout((() => {
                e.classList.add("aos-animate")
              }))
            }))
          })), e.classList.add("products-list__nav__button--active"), i.classList.add("products-list__item--active"), document.dispatchEvent(new CustomEvent("theme:resize")), n && (n.classList.remove("is-disabled"), document.dispatchEvent(new CustomEvent("theme:scroll"))), t.preventDefault()
        }))
      }))
    }

    initSliders() {
      this.slidersImages.forEach(((e, t) => {
        const s = e.closest("[data-tab-item]").querySelector("[data-slider-contents]"),
          i = new window.theme.Flickity(e, {
            fade: !0,
            pageDots: !1,
            prevNextButtons: !0,
            wrapAround: !0,
            adaptiveHeight: !0,
            asNavFor: s,
            on: {
              change: e => {
                this.flktyContent.length > 0 && this.flktyContent[t].select(e)
              }
            }
          });
        i.on("settle", (t => {
          const s = e.querySelectorAll("[data-product-single-media-wrapper]");
          for (let e = 0; e < s.length; e++) e === t ? s[e].querySelector("[data-product-single-media-image]").removeAttribute("tabindex") : s[e].querySelector("[data-product-single-media-image]").setAttribute("tabindex", "-1")
        })), this.flktyImages.push(i)
      })), this.slidersContents.forEach((e => {
        const t = new window.theme.Flickity(e, {
          fade: !0,
          pageDots: !1,
          prevNextButtons: !1,
          wrapAround: !0,
          adaptiveHeight: !0
        });
        t.on("settle", (t => {
          const s = e.querySelectorAll("[data-product-content-wrapper]");
          for (let e = 0; e < s.length; e++) e === t ? s[e].querySelectorAll("[data-product-link]").forEach((e => {
            e.removeAttribute("tabindex")
          })) : s[e].querySelectorAll("[data-product-link]").forEach((e => {
            e.setAttribute("tabindex", "-1")
          }))
        })), this.flktyContent.push(t)
      }))
    }

    initShopifyXrLaunch() {
      document.addEventListener("shopify_xr_launch", (() => {
        this.querySelector("[data-model]:not(.media--hidden)").dispatchEvent(new CustomEvent("xrLaunch"))
      }))
    }

    disconnectedCallback() {
      (this.slidersImages.length > 0 || this.slidersContents.length > 0) && document.removeEventListener("theme:resize", this.sliderResizeEvent)
    }
  }), customElements.get("product-model") || customElements.define("product-model", i)
}();
